// eslint-disable-next-line no-shadow
enum PaymentMethod {
  SITE,
  POS,
  MONEY,
}

export default PaymentMethod;
